import React from 'react';
import { Typography, Button } from '@material-ui/core';

import Icon from 'sharedComponents/Icon';
import Background from './components/Background';
import useStyles from './useStyles';

const Banner = ({ data }) => {
  const { title, subtitle, button } = data;
  const classes = useStyles();

  return (
    <Background>
      <div className={classes.content}>
        <Typography
          className={classes.title}
          variant="h1"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <Typography
          className={classes.subtitle}
          variant="subtitle1"
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
        <div className={classes.buttonContainer}>
          <Button className={classes.button} {...button.props}>
            {button.text}
            <Icon name="forwardArrow" className={classes.buttonIcon} />
          </Button>
        </div>
      </div>
    </Background>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Banner/Banner.js